import { render, staticRenderFns } from "./core.vue?vue&type=template&id=409fb9b7&scoped=true"
import script from "./core.vue?vue&type=script&lang=js"
export * from "./core.vue?vue&type=script&lang=js"
import style0 from "./core.vue?vue&type=style&index=0&id=409fb9b7&prod&lang=css"
import style1 from "./core.vue?vue&type=style&index=1&id=409fb9b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409fb9b7",
  null
  
)

export default component.exports